import { useState } from "react";
import { toast } from "sonner";
import { api, eur, formatApiError } from "@/lib/api";
import { BANK_INFO, fmtDate } from "@/lib/constants";

export const PreorderBox = ({ o }) => {
  const [busy, setBusy] = useState(false);
  const [bank, setBank] = useState(o.balance_method === "bonifico");
  const payBalance = async (method) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/orders/${o.id}/pay-balance`, { method, origin_url: window.location.origin });
      if (data.checkout_url) window.location.href = data.checkout_url;
      else { setBank(true); setBusy(false); }
    } catch (e) {
      toast.error(formatApiError(e));
      setBusy(false);
    }
  };
  return (
    <div className="mt-6 rounded-2xl border-2 border-violet-500 bg-violet-500/5 p-5 text-sm" data-testid="order-preorder-box">
      <p className="font-display text-lg text-violet-500">Preordine · uscita il {fmtDate(o.release_date)}</p>
      <p className="mt-1 text-stone-700">
        {o.deposit ? <>Caparra confirmatoria {o.deposit_pct}%: <b>{eur(o.deposit)}</b> · Saldo: <b data-testid="order-balance">{eur(o.balance_due || 0)}</b>{!o.balance_due && " (saldato)"}</> : "Pagamento totale anticipato."}
      </p>
      <p className="mt-1 text-stone-600">Spediremo l'ordine appena il prodotto sarà disponibile{o.balance_due ? " e il saldo sarà pagato" : ""}.</p>
      {o.balance_due > 0 && <p className="mt-1 text-xs text-stone-500" data-testid="balance-deadline">Il saldo va pagato entro 14 giorni dall'uscita, altrimenti l'ordine viene annullato e la caparra trattenuta.</p>}
      {o.deposit_forfeited && <p className="mt-1 font-semibold text-red-600" data-testid="deposit-forfeited">Ordine annullato: saldo non pagato entro 14 giorni, caparra trattenuta.</p>}
      {o.balance_due > 0 && o.payment_status === "partial" && (
        <div className="mt-4" data-testid="balance-actions">
          {o.balance_requested && <p className="mb-2 font-semibold text-violet-500">Il prodotto è uscito: salda l'ordine per riceverlo.</p>}
          <div className="flex flex-wrap gap-2">
            <button disabled={busy} onClick={() => payBalance("card")} className="rounded-full bg-black px-4 py-2 text-white" data-testid="balance-pay-card">Paga saldo con carta</button>
            <button disabled={busy} onClick={() => payBalance("paypal")} className="rounded-full border-2 border-black px-4 py-2" data-testid="balance-pay-paypal">PayPal</button>
            <button disabled={busy} onClick={() => payBalance("bonifico")} className="rounded-full border-2 border-black px-4 py-2" data-testid="balance-pay-bank">Bonifico / in negozio</button>
          </div>
          {bank && <p className="mt-3 text-stone-700" data-testid="balance-bank-info">Bonifico a {BANK_INFO.holder} · IBAN <span className="font-mono">{BANK_INFO.iban}</span> · causale <span className="font-mono">Saldo {o.order_number}</span>. Oppure paga direttamente in negozio.</p>}
        </div>
      )}
    </div>
  );
};
